import { action, makeObservable, observable, override } from 'mobx';

import { ModalState } from '../../../app/shared/ModalState';
import { PricelistFormModalTranslation } from '../../localization/ModuleTranslation';
import type { CustomerPricelistData } from '../../model';
import PricelistFormState from '../PricelistForm/PricelistFormState';

export default class PricelistFormModalState<TForm extends PricelistFormState = PricelistFormState> extends ModalState {
  @observable public errorMessage = '';
  @observable public isPending = false;

  public constructor(
    public readonly translation: PricelistFormModalTranslation,
    public readonly form: TForm,
    private readonly onSuccess: (pricelist: CustomerPricelistData) => void,
  ) {
    super();
    makeObservable(this);
  }

  @override
  public open(pricelist?: CustomerPricelistData): Promise<void> {
    this.form.reset(pricelist);
    this.setErrorMessage('');

    return super.open();
  }

  @action.bound
  public async submit(): Promise<void> {
    if (this.isPending) {
      return;
    }

    this.setIsPending(true);
    this.setErrorMessage('');

    const result = await this.form.submit();

    if (result.isSuccess) {
      this.close();
      this.onSuccess(result.pricelist);
    } else if (result.errorMessage) {
      this.setErrorMessage(result.errorMessage);
    }

    this.setIsPending(false);
  }

  @action
  private setErrorMessage(errorMessage: string): void {
    this.errorMessage = errorMessage;
  }

  @action
  private setIsPending(isPending: boolean): void {
    this.isPending = isPending;
  }
}
